import { Component, OnInit,Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import * as _ from "underscore";
import { InwardFilter } from '../../../shared/classes/filter';
import { SortBy } from '../../../Enums/sortEnums';
import { OfficesService } from '../../../shared/services/offices.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InwardService } from 'src/app/shared/services/inward.service';

@Component({
  selector: 'app-inward-filter',
  templateUrl: './inward-filter.component.html',
  styleUrls: ['./inward-filter.component.less']
})
export class InwardFilterComponent implements OnInit,OnDestroy {


  @Input() column;

  @Output() gridFiltersApplied = new EventEmitter();

  @Input() registrationArray;

  filteredData : any;

  @Input() tableSettings;

  @Input() statusArray;

  @Input() brfromArray;

  @Input() reByArray;

  private unsubscribe$ =new Subject<void>();


  selectAllRegType: {isChecked: boolean} = {isChecked : true};
  selectAllStatusType: {isChecked: boolean} = {isChecked : true};
  selectAllFromType: {isChecked: boolean} = {isChecked : true};
  selectAllByType: {isChecked: boolean} = {isChecked : true};

  isUnSelectAll: boolean = false;
  
  constructor(private inwardService: InwardService) { }

  ngOnInit() {

    this.inwardService.resetFilters
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {   
         
      this.resetFilters();
      
      this.inwardService.resetHeaders.next();          
    });

    this.checkSelectAllFilter();
    this.checkFilterValue();
  }


  selectAllRegTypeFilter(check) {
    if (check) {
      this.registrationArray.forEach(item => {
        item.isCheck = true;
      })

    }
    else {
      this.registrationArray.forEach(item => {
        item.isCheck = false;
      })

    }
  }

  selectAllStatusFilter(check) {
    if (check) {
      this.statusArray.forEach(item => {
        item.isCheck = true;
      })


    }
    else {
      this.statusArray.forEach(item => {
        item.isCheck = false;
      })

    }
  }

  selectAllFromFilter(check) {
    if (check) {
      this.brfromArray.forEach(item => {
        item.isCheck = true;
      })


    }
    else {
      this.brfromArray.forEach(item => {
        item.isCheck = false;
      })

    }
  }

  selectAllByFilter(check) {
    if (check) {
      this.reByArray.forEach(item => {
        item.isCheck = true;
      })


    }
    else {
      this.reByArray.forEach(item => {
        item.isCheck = false;
      })

    }
  }

  checkFilterValue(){

    if(InwardFilter.regTypeList.length == 0 && InwardFilter.regTypeList.indexOf('None') < 0){
      
      this.selectAllRegTypeFilter(true);
    }
    if(InwardFilter.statusList.length==0 && InwardFilter.statusList.indexOf('None')<0){
        this.selectAllStatusFilter(true);
    }
    if(InwardFilter.broughtFromList.length==0 && InwardFilter.broughtFromList.indexOf('None')<0){
      this.selectAllFromFilter(true);
    }
    if(InwardFilter.receivedByList.length==0 && InwardFilter.receivedByList.indexOf('None')<0){
      this.selectAllByFilter(true);
    }
  }

  


  checkSelectAllFilter(){
    
    if(InwardFilter.regTypeList.length >0 || InwardFilter.regTypeList.indexOf('None') > -1){
  
      this.selectAllRegType.isChecked = false;
    }
    if(InwardFilter.statusList.length >0 || InwardFilter.statusList.indexOf('None') > -1){
  
      this.selectAllStatusType.isChecked = false;
    }
    if(InwardFilter.broughtFromList.length >0 || InwardFilter.broughtFromList.indexOf('None') > -1){
  
      this.selectAllFromType.isChecked = false;
    }
    if(InwardFilter.receivedByList.length >0 || InwardFilter.receivedByList.indexOf('None') > -1){
  
      this.selectAllByType.isChecked = false;
    }
     
  }

      // Selection/unselection of filter options
  togglefilter(arrayType,selectAllValue,checked){
    
        var allTypeCount = arrayType.length;
        var checkedTypeCount = 0;
        arrayType.forEach(item => {
          if (item.isCheck) {              
            checkedTypeCount = checkedTypeCount + 1;
          }
        })

                  
        if(!checked){
          
            selectAllValue.isChecked = false;
        }
        else{
          if(allTypeCount == checkedTypeCount){
            selectAllValue.isChecked = true;
          }
          else{
            selectAllValue.isChecked = false;
          }
        }
  }

  checkSelectedRegType(arrayList,column){
    let selectedType =[];
    column.isFilterIcon = true;
    arrayList.forEach(item => {
      if (item.isCheck) {

        selectedType.push(item.name);

      }
    })


      if(selectedType.length == arrayList.length){
        InwardFilter.regTypeList = [];

      }
      else{
        return InwardFilter.regTypeList = selectedType;
      }
    
  }

  checkSelectedStatusType(arrayList,column){
    
    let selectedType =[];
    column.isFilterIcon = true;
    arrayList.forEach(item => {
      if (item.isCheck) {            
        selectedType.push(item.name);            
}
    })

    
      if(selectedType.length == arrayList.length){
        InwardFilter.statusList = [];
          //column.isFilterIcon = false;          
      }
      else{
        return InwardFilter.statusList = selectedType;
      }
    
  }
  
  checkSelectedFromType(arrayList,column){
    
    let selectedType =[];
    column.isFilterIcon = true;
    arrayList.forEach(item => {
      if (item.isCheck) {            
        selectedType.push(item.name);            
}
    })

    
      if(selectedType.length == arrayList.length){
        InwardFilter.broughtFromList = [];
          //column.isFilterIcon = false;          
      }
      else{
        return InwardFilter.broughtFromList = selectedType;
      }
    
  }

  checkSelectedByType(arrayList,column){
    
    let selectedType =[];
    column.isFilterIcon = true;
    arrayList.forEach(item => {
      if (item.isCheck) {            
        selectedType.push(item.name);            
      }
    })

    
      if(selectedType.length == arrayList.length){
        InwardFilter.receivedByList = [];
          //column.isFilterIcon = false;          
      }
      else{
        return InwardFilter.receivedByList = selectedType;
      }
    
  }

  onFilterApply(column){

    this.isUnSelectAll = false;

    if(column.isResNameSortA) {
      column.sortOrder = 'Asc';
      
    }else if (column.isResNameSortD) {
      column.sortOrder = 'Desc';

    }else if (column.isResNameSortN) {
      column.sortOrder = '';
    
    }

    column.displaysort = false;
   
    if(column.sortBy == SortBy.Reg){          
      this.checkSelectedRegType(this.registrationArray,column);
    }
    if(column.sortBy == SortBy.Status){          
      this.checkSelectedStatusType(this.statusArray,column);
    }
    if(column.sortBy == SortBy.BroughtFrom){          
      this.checkSelectedFromType(this.brfromArray,column);
    }
    if(column.sortBy == SortBy.ReceivedBy){          
      this.checkSelectedByType(this.reByArray,column);
    }     
    if(!this.isUnSelectAll){
    column.isFilterApplied = true;
  
    this.gridFiltersApplied.emit(true);
    }

  }




  resetEvents(){
    this.tableSettings.columns.forEach(item => {
      item.displaysort = false;
    })
}

  resetFilters()
  {        
    this.selectAllRegTypeFilter(true);
    this.selectAllRegType.isChecked = true;   
    this.selectAllStatusFilter(true);
    this.selectAllStatusType.isChecked = true;   
    this.selectAllFromFilter(true);
    this.selectAllFromType.isChecked = true;
    this.selectAllByFilter(true);
    this.selectAllByType.isChecked = true; 
  }
  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
